import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import FieldSchemePageQuery from '@atlassian/jira-relay/src/__generated__/FieldSchemePageQuery.graphql.ts';

export const globalAdminFieldSchemeEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-jira-admin-pages-field-scheme" */ './src/FieldSchemeApp.tsx'
			),
	),
	getPreloadProps: ({ context: { match }, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			fieldSchemePageQueryRef: {
				parameters: FieldSchemePageQuery,
				variables: {
					cloudId: tenantContext.cloudId,
					input: {
						schemeId: match.params?.schemeId || '',
					},
				},
				options: {
					fetchPolicy: 'network-only' as const,
				},
			},
		},
		extraProps: {
			schemeId: match.params?.schemeId || '',
		},
	}),
});
